import { useRef } from 'react';
import { ModalDialog } from '../../components/modalDialog.tsx';
import { MaintenanceLogTable, MaintenanceLogTableRef } from './maintenanceLogTable.tsx';


interface Props {
    equipment: string;
    onClose: () => void;
}

export function MaintenanceLogDialog({
    equipment,
    onClose,
}: Props) {

    const maintenanceLogTableRef = useRef<MaintenanceLogTableRef>(null);

    return (
        <ModalDialog
            isOpen={true}
            frameClassName='modal-frame--fixed_width'
            cancelOnOutsideClick={true}
            onCancel={onClose}
        >
            <MaintenanceLogTable
                ref={maintenanceLogTableRef}
                style={{ marginTop: '0.5rem', marginBottom: '2rem' }}
                equipment={equipment}
            />
            <div className='dialog--button-bar'>
                <button
                    className='button--large'
                    onClick={() => maintenanceLogTableRef.current?.onAddOperationClicked()}
                    children='Add operation'
                />
                <button
                    className='button--large'
                    onClick={onClose}
                    children='Close'
                />
            </div>
        </ModalDialog>
    )
}
